var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511.35 455.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rules"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.28,119.63a61,61,0,0,0-110.89,0H60.88v54.52H392.12a61.05,61.05,0,0,0,107.44,0h72.67V119.63Z",
    transform: "translate(-60.88 -84.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.26,250.61a61,61,0,0,0-55.44,35.52H60.88v54.52h72.66a61.06,61.06,0,0,0,107.45,0H572.23V286.13H242.71A61,61,0,0,0,187.26,250.61Z",
    transform: "translate(-60.88 -84.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.84,417.11a61,61,0,0,0-55.45,35.52H60.88v54.52H392.12a61.05,61.05,0,0,0,107.44,0h72.67V452.63h-71A61,61,0,0,0,445.84,417.11Z",
    transform: "translate(-60.88 -84.11)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rules_Envirotainer",
    "data-name": "Rules Envirotainer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.28,119.63a61,61,0,0,0-110.89,0H60.88v54.52H392.12a61.05,61.05,0,0,0,107.44,0h72.67V119.63Z",
    transform: "translate(-60.88 -84.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.26,250.61a61,61,0,0,0-55.44,35.52H60.88v54.52h72.66a61.06,61.06,0,0,0,107.45,0H572.23V286.13H242.71A61,61,0,0,0,187.26,250.61Z",
    transform: "translate(-60.88 -84.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.84,417.11a61,61,0,0,0-55.45,35.52H60.88v54.52H392.12a61.05,61.05,0,0,0,107.44,0h72.67V452.63h-71A61,61,0,0,0,445.84,417.11Z",
    transform: "translate(-60.88 -84.11)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.eae3a4f214db1c03aae6458c73ce0cd9.svg";
export { ForwardRef as ReactComponent };